// src/hooks/useOAuthCallback.js
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { message } from "antd";
import { getCurrentUser } from "../redux/thunks/authThunks";
import { axiosUsers } from "../../api/axios";

export const useOAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    /* =========================
       1️⃣ HYDRATE TOKEN (CRUCIAL FIX)
    ========================= */
    const frontToken = searchParams.get("token") || Cookies.get("accessToken");

    if (frontToken) {
      // Persist token
      Cookies.set("accessToken", frontToken);

      // 🔥 LE FIX PRINCIPAL 🔥
      axiosUsers.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${frontToken}`;
    }

    /* =========================
       2️⃣ HANDLE ERRORS
    ========================= */
    const error = searchParams.get("error");
    if (error) {
      message.error("Authentication failed");
      navigate("/LoginPatient", { replace: true });
      return;
    }

    /* =========================
       3️⃣ FETCH CURRENT USER
    ========================= */
    dispatch(getCurrentUser())
      .unwrap()
      .then((user) => {
        const userId =
          user?.id ||
          user?.userId ||
          Cookies.get("userId") ||
          Cookies.get("id");

        if (!userId) {
          throw new Error("User ID not resolved");
        }

        // Persist ID everywhere

        Cookies.set("userId", userId);
        Cookies.set("id", userId);

        message.success("Welcome back!");
        navigate(`/feed/${userId}`, { replace: true });
      })
      .catch((err) => {
        console.error("OAuth hydration failed:", err);
        message.error("Failed to load your profile");
        navigate("/LoginPatient", { replace: true });
      });
  }, [dispatch, navigate, searchParams]);
};
